// extracted by mini-css-extract-plugin
module.exports = {"root":"DemoClose_root__lMZ22"};